var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgKvBlob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 418,
    height: 384,
    viewBox: "0 0 418 384",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M389.543 165.12C381.822 116.594 349.754 74.6647 307.58 49.3538C267.571 25.3418 218.624 23.2731 173.553 35.4904C131.988 46.7572 100.837 77.1716 75.8153 112.177C50.1194 148.127 29.6353 188.186 32.9413 232.211C36.6362 281.415 51.548 336.204 94.4731 360.639C136.071 384.318 185.413 357.128 231.867 345.446C273.832 334.893 318.543 329.686 347.007 297.133C378.665 260.927 397.093 212.565 389.543 165.12Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgKvBlob);
export default __webpack_public_path__ + "static/media/bg-kv-blob.9eb713dc83ffe0a5e2b8df538db29195.svg";
export { ForwardRef as ReactComponent };